const placaRegex = /([\w\d]{7})/;

export { placaRegex };
